// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiAuthentik as RawSiAuthentik } from "react-icons/si";
export const SiAuthentik = /* @__PURE__ */ createIcon(RawSiAuthentik, "SiAuthentik", 0);
